module.exports = __webpack_public_path__ + "img/checked.773b900b.svg";